<template>
  <div>
    <panel title="Informações do Produto">
      <div class="l-row">
        <form-group :label="$t('title.label')" :columns="6" :error="getErrorByProductId('title', product.productId)">
          <input class="form-input" type="text" v-model="product.title">
        </form-group>

        <form-group :label="$t('brand.label')" :columns="6" :error="getErrorByProductId('brand', product.productId)">
          <input class="form-input" type="text" v-model="product.brand">
        </form-group>

        <form-group label="Descrição" :columns="12" slot="product"
                    :error="getErrorByProductId('description', product.productId)" :required="true">
          <quill-editor :options="{ placeholder: 'Adicione a descrição do seu produto aqui' } "
                        v-model="product.description"/>
        </form-group>

        <form-group label="NCM" :columns="6" :error="getErrorByProductId('ncm', product.productId)">
          <input class="form-input" type="text" v-model="product.ncm">
        </form-group>

        <form-group :label="$t('ageGroup.label')" :columns="6"
                    :error="getErrorByProductId('ageGroup', product.productId)">
          <select v-model="product.ageGroup" class="form-select">
            <option :value="null">
              Selecione
            </option>
            <option value="adult">
              {{ $t('ageGroup.adult.label') }}
            </option>
            <option value="kids">
              {{ $t('ageGroup.kids.label') }}
            </option>
            <option value="both">
              {{ $t('ageGroup.both.label') }}
            </option>
          </select>
        </form-group>

        <form-group :label="$t('warranty.label')" :columns="6"
                    :error="getErrorByProductId('warranty', product.productId)">
          <input class="form-input" type="text" v-model="product.warranty">
        </form-group>

        <form-group :label="$t('warrantyTime.label')" :columns="6"
                    :error="getErrorByProductId('warrantyTime', product.productId)">
          <div class="form-flex">
            <input class="form-input" type="text" v-model="product.warrantyTime">
            <span class="form-addon">dias</span>
          </div>
        </form-group>

        <form-group :label="$t('referenceCode.label')" :columns="6" :error="getErrorByProductId('referenceCode', product.productId)">
          <input class="form-input" type="text" v-model="product.referenceCode">
        </form-group>

      </div>
    </panel>

    <panel title="Variações">
      <variation  v-for="variation in product.variations" :key="variation" :variation="variation"/>
    </panel>
  </div>
</template>

<script>
  import Panel from '@/components/template/Panel'
  import FormGroup from '@/components/template/FormGroup'
  import { mapGetters } from 'vuex'
  import Variation from '@/components/ProductProvide/Edit/Api/Variation'
  import ModalAddImage from '@/components/ProductProvide/Edit/Api/ModalAddImage'
  import { quillEditor } from 'vue-quill-editor'

  export default {
    data: () => ({
      addingImage: false
    }),
    props: {
      product: {
        type: Object,
        required: true
      }
    },
    methods: {
      uploadedImage (urls, variations) {
        for (let i in variations) {
          const sku = variations[i].sku
          const variation = this.product.variations.find(variation => variation.sku === sku)

          if (variation === undefined) {
            continue
          }

          for (let j in urls) {
            variation.images.push(urls[j])
          }
        }
      },
      formatProduct () {
        return this.product
      }
    },
    computed: {
      ...mapGetters('errors', [
        'getErrorByProductId'
      ])
    },
    components: {
      Panel,
      FormGroup,
      Variation,
      ModalAddImage,
      quillEditor
    }
  }
</script>

<style lang="sass" scoped>
  .margin
    margin-bottom: 10px

  .c-box__body
    border-color: #bde2fb

  .check-box
    border-color: #7872ff

  .c-modalCard__body
    overflow: visible
</style>



// WEBPACK FOOTER //
// Product.vue?0ff6f437